export enum ScreenSize {
  MOBILE,
  TABLET,
  DESKTOP,
}
